import {
  RequirementContextType,
  RequirementTableItemData,
  TableCellProps
} from "../types";
import { extendRequirementStatusPill } from "./extendRequirementStatusPill";
import { extendRequirementStatusSecondaryTextProps } from "./extendRequirementStatusSecondaryTextProps";

export const extendRequirementStatusCell = (
  props: TableCellProps,
  requirement: RequirementTableItemData,
  contextType: RequirementContextType
): TableCellProps => {
  return {
    ...props,
    pill: props.pill
      ? extendRequirementStatusPill(requirement, contextType, props.pill)
      : undefined,
    ...extendRequirementStatusSecondaryTextProps(
      requirement,
      contextType,
      props.secondaryText
    )
  };
};
